<template>
  <div class="card" :class="{active: card.rate > 0}">
    <div class="title line-clamp-1">{{ card.name }}</div>
    <div class="state">{{ card.rate > 0 ? '已学习' : '未学习' }}</div>
  </div>
</template>

<script>
  import ImgLazy from '@/components/ImgLazy'

  export default {
    name: "card-course",
    components: {ImgLazy},
    props: {
      card: {
        type: Object,
        required: true,
        default: () => {return {}}
      }
    },
  }
</script>

<style lang="less" scoped>
  .card {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    height: 42px;
    line-height: 42px;
    color: #3c3c3c;

    &.active {
      color: #caab6e;
    }

    .title {
      font-size: 16px;
      height: 42px;
      flex: 1;
    }

    .state {
      font-size: 10px;
      width: 60px;
      text-align: right;
    }
  }
</style>